const services = [
  {
    icon: 'ri-book-3-line',
    title: 'Monthly Bookkeeping & Reconciliation',
    desc: 'Clean, accurate monthly books tailored to your operation. Chart of accounts optimized for restaurants or trades, not generic templates.',
    image:
      'https://readdy.ai/api/search-image?query=Clean%20modern%20financial%20spreadsheet%20and%20documents%20on%20minimal%20white%20desk%2C%20soft%20natural%20lighting%2C%20organized%20receipts%20and%20calculator%2C%20professional%20bookkeeping%20workspace%20aesthetic%2C%20warm%20neutral%20tones%2C%20editorial%20photography&width=600&height=400&seq=svc-books-01&orientation=landscape',
  },
  {
    icon: 'ri-money-cny-circle-line',
    title: 'Payroll & Tipped-Wage Compliance',
    desc: 'FICA tip credit calculations, tipped minimum wage compliance, Tip Pooling & Reporting Act adherence for Virginia hospitality.',
    image:
      'https://readdy.ai/api/search-image?query=Restaurant%20server%20tips%20and%20receipts%20on%20counter%20with%20digital%20tablet%20showing%20payroll%20dashboard%2C%20modern%20POS%20system%20background%2C%20warm%20restaurant%20lighting%2C%20professional%20photography%20style%2C%20soft%20focus%20background&width=600&height=400&seq=svc-payroll-01&orientation=landscape',
  },
  {
    icon: 'ri-government-line',
    title: 'Sales Tax & VA Regulatory Compliance',
    desc: 'Virginia sales tax filing, meals tax calculations, ABC compliance support, and local jurisdiction reporting across Richmond, Henrico, and Chesterfield.',
    image:
      'https://readdy.ai/api/search-image?query=Virginia%20state%20capital%20building%20exterior%20with%20modern%20business%20documents%20and%20tax%20forms%20in%20foreground%2C%20clean%20professional%20composition%2C%20soft%20blue%20sky%2C%20editorial%20photography%2C%20warm%20natural%20lighting&width=600&height=400&seq=svc-tax-01&orientation=landscape',
  },
  {
    icon: 'ri-building-line',
    title: 'Job Costing & Project Profitability',
    desc: 'Per-project P&L tracking, change order accounting, retainage reconciliation, and overhead allocation so you know which jobs actually earn.',
    image:
      'https://readdy.ai/api/search-image?query=Contractor%20reviewing%20blueprints%20and%20financial%20spreadsheet%20on%20tablet%20at%20construction%20site%20office%2C%20hard%20hat%20and%20tools%20in%20background%2C%20warm%20daylight%2C%20professional%20construction%20photography%20style%2C%20clean%20composition&width=600&height=400&seq=svc-jobs-01&orientation=landscape',
  },
  {
    icon: 'ri-restaurant-line',
    title: 'Prime Cost & Inventory Control',
    desc: 'Food cost percentage tracking, menu engineering data, vendor price variance alerts, and inventory turnover analysis that protects your margins.',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20restaurant%20kitchen%20inventory%20shelves%20with%20organized%20spices%20and%20ingredients%2C%20digital%20tablet%20showing%20cost%20reports%2C%20warm%20ambient%20kitchen%20lighting%2C%20clean%20commercial%20kitchen%20aesthetic%2C%20editorial%20food%20photography&width=600&height=400&seq=svc-inventory-01&orientation=landscape',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: 'Custom Reporting & Advisory',
    desc: 'Owner-friendly dashboards showing what matters: prime cost trends, labor ratios, job profitability, cash flow forecasts, and actionable KPIs.',
    image:
      'https://readdy.ai/api/search-image?query=Modern%20financial%20dashboard%20on%20laptop%20screen%20showing%20charts%20and%20graphs%20with%20green%20and%20teal%20accents%2C%20clean%20minimalist%20desk%20setup%2C%20soft%20natural%20lighting%2C%20professional%20business%20photography%20style&width=600&height=400&seq=svc-reports-01&orientation=landscape',
  },
  {
    icon: 'ri-plug-line',
    title: 'Software Setup & Integrations',
    desc: 'Seamless connection of Toast, Square, Clover, QuickBooks, Xero, ServiceTitan, Housecall Pro, and other tools into one clean financial system.',
    image:
      'https://readdy.ai/api/search-image?query=Multiple%20software%20app%20icons%20and%20dashboard%20interfaces%20on%20modern%20computer%20screens%20connected%20by%20subtle%20network%20lines%2C%20clean%20tech%20integration%20concept%2C%20soft%20warm%20lighting%2C%20minimalist%20professional%20photography&width=600&height=400&seq=svc-software-01&orientation=landscape',
  },
  {
    icon: 'ri-file-search-line',
    title: 'Year-End Cleanup & CPA Coordination',
    desc: 'Organized, audit-ready books delivered to your CPA. We handle the prep work so tax season is painless and you maximize every deduction.',
    image:
      'https://readdy.ai/api/search-image?query=Organized%20financial%20documents%20and%20tax%20folders%20stacked%20neatly%20on%20modern%20desk%20with%20calendar%20showing%20year%20end%2C%20clean%20minimalist%20office%20aesthetic%2C%20soft%20natural%20lighting%2C%20professional%20editorial%20photography%20style&width=600&height=400&seq=svc-cleanup-01&orientation=landscape',
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12 md:mb-16">
            <p className="text-accent-600 text-sm font-semibold tracking-widest uppercase mb-3">
              What We Deliver
            </p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-primary-950 max-w-3xl leading-tight">
              Services Built for
              <span className="italic text-accent-600"> Your Books</span>
            </h2>
            <p className="text-foreground-600 text-base md:text-lg max-w-2xl mt-4 leading-relaxed">
              Every service is designed around the specific financial workflows of restaurants
              and skilled trades — not generic small-business templates.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
            {services.map((svc, i) => (
              <div
                key={i}
                className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-accent-300/50 hover:shadow-lg transition-all"
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={svc.image}
                    alt={svc.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary-950/40 to-transparent" />
                </div>
                <div className="p-5">
                  <div className="w-9 h-9 rounded-lg bg-accent-100 flex items-center justify-center mb-3">
                    <i className={`${svc.icon} text-accent-600 text-lg`} />
                  </div>
                  <h3 className="font-heading text-base md:text-lg text-primary-950 font-semibold mb-2 leading-snug">
                    {svc.title}
                  </h3>
                  <p className="text-foreground-600 text-sm leading-relaxed">
                    {svc.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}